import React, { FC, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { EnterpriseCardProfile } from '../card/EnterpriseCardProfile';
import { UserContext } from '../../../user/UserContext';
import { EntitiesCardFooter } from '../../../components/entities-card/EntitiesCardFooter';
import { EntitiesCardBody } from '../../../components/entities-card/EntitiesCardBody';
import { EnterpriseCardType } from '../card/enterpriseCard.types';
import {
  withRestrictedModal,
  WithRestrictedModalProps,
} from '../../../components/modal/components/modal-restricted/withRestrictedModal';

type Props = {
  enterprise: EnterpriseCardType;
  source: string;
} & WithRestrictedModalProps;

const RawEnterpriseCard: FC<Props> = ({
  enterprise,
  source,
  openRestrictedModal,
}) => {
  const { accessPremium } = useContext(UserContext);
  const handleClick = (src: string) => () => {
    if (!accessPremium) {
      openRestrictedModal(src);
    }
  };

  return (
    <>
      <EntitiesCardBody>
        <EnterpriseCardProfile
          enterprise={enterprise}
          href={
            accessPremium
              ? `${enterprise.url}?source=${source}-header`
              : undefined
          }
          onClick={handleClick(`${source}-header`)}
        />
      </EntitiesCardBody>
      <EntitiesCardFooter
        href={
          accessPremium
            ? `${enterprise.url}?source=${source}-footer`
            : undefined
        }
        onClick={handleClick(`${source}-footer`)}
      >
        <FormattedMessage id="app.entities.popover.footer" />
      </EntitiesCardFooter>
    </>
  );
};

export const EnterpriseCard = withRestrictedModal(RawEnterpriseCard);
